var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

function getCreativeId(drawerEle){
    if(drawerEle.dataset && drawerEle.dataset.creativeId){
        return drawerEle.dataset.creativeId;
    }
    return (drawerEle.id || drawerEle.classList[0]);
}
function _handleDrawerOpen(ev) {
    var drawerEle = ev.target;
    var eventObj;
    var noRefresh = (drawerEle.dataset && drawerEle.dataset.noRefresh)  ? drawerEle.dataset.noRefresh : false;
    var eventData = {
        'action_name':'widget_view',
        'action_cause': 'drawer_open',
        'creative_id': getCreativeId(drawerEle) // no ID on the drawer? grab the first class name
    };
    if (drawerEle.dataset['eventOptions']) {
        // e.g.   data-event-options='{"test": "dope"}'
        $.extend(true, eventData, JSON.parse(drawerEle.dataset['eventOptions']));
    }
    eventObj = {
        'ads': {
            'disable_refresh': noRefresh
        },
        'event_type': 'widget_view',
        'event_data': eventData
    };
    eventToolbox.fireAction(eventObj);
}


$(function() {
    // only listen to drawers that are inside this div (made by the macro)
    $('div[data-drawer-list]').on('shown.bs.modal', _handleDrawerOpen);
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/drawer-engagement-handler/drawer-engagement-handler.js
// module id = 432
// module chunks = 36